module.exports = {"id":"220334","name":"Óscar Romero","rating":"76","photo":"./data/images/photos/1/220334.png","club":{"name":"Agents libres","logo":"./data/images/clubs/Agentslibres.png"},"positions":["MD","MOC","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/OscarRomero0.json
// module id = 3314
// module chunks = 0